import baseApi from '../utils/ApiUtils';

export const uploadPhoto = (method, params, payload, header) => {
  return baseApi(`/attachments/`, method, null, payload,null, header).then(response => {
    return response.data;
  });
};

export const uploadAction = (method, id, params, payload, header) => {
  return baseApi(`/attachments/${id}/`, method, null, payload,null, header).then(response => {
    return response.data;
  });
};